/* script */
//
//
//
//
//
//

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';

const __vue_script__ = {
    name: 'RegistrationUrlPicker',

    components: { BaseInput },

    extends: BaseControl,

    props: {
        event: {
            type: Object,
            default: () => ({})
        },

        brandedApp: {
            type: String,
            default: null
        },

        useAdvancedReg: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            innerValue: this.value,
            validations: 'required|alpha_dash',
            flags: {}
        };
    },

    computed: {
        // Pass-through attributes
        /** @returns {object} */
        attrs() {
            /* eslint-disable no-unused-vars */
            const { errors, hint, name, event, value, ...attrs } = Object.assign(this.$options.propsData, this.$attrs);
            /* eslint-enable no-unused-vars */

            return attrs;
        },

        /** @returns {string} */
        branding() {
            return this.brandedApp || this.event.branded_app || '...';
        },

        /** @returns {string} */
        urlPreview() {
            const path = this.innerValue || '';
            const url = this.$utils.url.getWebappRegistrationUrl(this.branding, path, {
                noCache: false,
                whiteLabelDomain: this.event.white_label_domain,
                useAdvancedReg: this.useAdvancedReg
            });

            return this.$i18n.t('registration.activation.url_preview', [url]).toString();
        },

        /** @returns {string} */
        validationString() {
            let validation = `unique_branding_url:${this.event._id || ''}`;
            const branding = this.brandedApp || this.event.branded_app;
            if (branding) {
                validation += `,${this.branding}`;
            }

            return validation;
        }
    },

    watch: {
        flags: {
            deep: true,
            handler() {
                this.validations = this.getValidations();
            }
        }
    },

    mounted() {
        this.flags = this.$refs.provider.flags;
    },

    methods: {
        /**
         * Calculates the validators for the field.
         * If the field didn't change we don't need to check the uniqueness
         * because otherwise we won't be able to save.
         */
        getValidations() {
            let validations = ['required', 'alpha_dash'];

            if (this.flags.changed || !this.edit) {
                validations.push(this.validationString);
            }

            return validations.join('|');
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-provider", {
    ref: "provider",
    staticClass: "registration-url-picker",
    attrs: {
      rules: _vm.validations,
      slim: true,
      name: _vm.name,
      debounce: 300,
      immediate: true,
    },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function (ref) {
            var errors = ref.errors
            var flags = ref.flags
            return [
              _c(
                "base-input",
                _vm._b(
                  {
                    ref: "regUrl",
                    attrs: {
                      errors: errors,
                      hint: _vm.hint || _vm.urlPreview,
                      name: _vm.name,
                    },
                    on: {
                      input: function (data) {
                        return _vm.$emit("input", data)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "after-label",
                          fn: function () {
                            return [_vm._t("after-label")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                    model: {
                      value: _vm.innerValue,
                      callback: function ($$v) {
                        _vm.innerValue = $$v
                      },
                      expression: "innerValue",
                    },
                  },
                  "base-input",
                  _vm.attrs,
                  false
                ),
                [_vm._t("default")],
                2
              ),
            ]
          },
        },
      ],
      null,
      true
    ),
  })
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/pickers/RegistrationUrlPicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__